// loadVue.js
let Vue;

if (process.env.VUE_APP_ENV === 'development') {
    console.log("获取本地 vue");
    Vue = require('vue');
    globalThis.Vue = Vue;
} else {
    // console.log("获取 cdn vue");
    Vue = window.Vue;
    globalThis.Vue = Vue;
}

export default Vue;
